import { WalletType } from "@tria-sdk/web-test";

export const walletType: WalletType = { embedded: true, supportAa: true };
export const sponsorshipPolicyIds = {
  FUSE: "sp_cheerful_thing",
  POLYGON: "sp_slim_namor",
};
export const accountType = "Etherspot";
export const baseUrl = process.env.REACT_APP_BASE_URL || "";
export const walletUrl = "https://tria-wallet-tria-triahq.vercel.app";
export const socketUrl = process.env.REACT_APP_SOCKET_URL || "";

type KEYRING_ENV = "testnet" | "mainnet" | "mainnet-staging";

let env: KEYRING_ENV | undefined;

const keyring_env: string = "testnet";

export { keyring_env, env };
